import React from 'react';

import Code from '../base';

const codestring = `const fetch = require('node-fetch');
const jose = require('jose');

// permission stuff
const username = '6d11075e-29ad-42b5-9bca-b5f278f9133c';
const password = 'UiHmmDOiUkH6c1b6VntTb4tzSy1jrCUha2N41DH73RY';
const token = {"use":"sig","kty":"EC","kid":"6d11075e-29ad-42b5-9bca-b5f278f9133c","crv":"P-256","x":"7X-4jabUvQpZkIWWnbt7xpZHZY6cg8aoMt2JDQZZFzk","y":"Q2QnijBzEkWIKgeX73R6jsgRy9SyOluq9dkZVILRWt0","d":"vhrEnF43ePIOCWmgAJDsWQVmTV9InDMB1F3Ao9lBExk"};

// IDs
const business_id = '813c88b0fb668a0b7087be0550000fd0';
const account_id = '613b945a-2368-4dd1-9d83-b951bc77156d';
// must be unique!
const destination_account = 'd8bc0fff-dd74-41f3-a116-04a8c260e0b9';
const batch_id = 'd4afeba2-7847-4745-8db5-ce6d31754989';

const url = \`https://b2b-api.lana-staging.xyz/business/\${business_id}/accounts/\${account_id}/batches\`;
const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Basic ' + Buffer.from(\`\${username}:\${password}\`).toString('base64'),
};

const buildSignature = ({id, ts, business, amount, currency, source_uri, dest_uri}, token) => {
    const key = jose.JWK.asKey(token);
    const payload = {
        id: id,
        vTS: ts,
        bID: business,
        a: amount,
        c: currency,
        s: source_uri,
        d: dest_uri,
    }

    return jose.JWT.sign(payload, key, {algorithm: 'ES256'});
};

const create_batch = ({batch_id, description}, items) => {
    const add_item = item => {
        const data = JSON.stringify(item);
        console.log(data);
        fetch(url + '/' + batch_id + '/items', { headers: headers, method: 'POST', body: data }).then(response => {
            return response.json()
        }).then(data => {
            console.log(data);
        });
    };

    const b = JSON.stringify({ description: description });
    fetch(url + '/' + batch_id, { headers: headers, method: 'PUT', body: b }).then(response => {
        if (response.status !== 201) {
            throw Error(response.status);
        }
    }).then(data => {
        items.map(i => {
            add_item(i);
        });
    });
};

const batch_data = {
    id: batch_id,
    description: 'Here goes the description'
};

const n = new Date();
const value_ts = Math.floor(n / 1000);

const items = [{
    id: n.getFullYear() + '-' + ('0' + (n.getMonth()+1)).slice(-2) + '-' + '0ce0148e-390e-48b9-8346-65b814ac3d56',
    amount: 100,
    currency: 'MXN',
    destination_name: 'Here goes the destination name',
    destination_url: 'https://lana-dev.xyz/2092bc45-8dfd-4f3b-ad2c-32bf2494d77a',
    destination_uri: destination_account_uri,
    description: 'Here goes the description',
    value_ts: value_ts,
}, {
    id: n.getFullYear() + '-' + ('0' + (n.getMonth()+1)).slice(-2) + '-' + '9e3f1319-48dd-4f7d-8ced-02942836c842',
    amount: 200,
    currency: 'MXN',
    destination_name: 'Here goes the destination name 2',
    destination_url: 'https://lana-dev.xyz/2092bc45-8dfd-4f3b-ad2c-32bf2494d77a',
    destination_uri: destination_account_uri,
    description: 'Here goes the description 2',
    value_ts: value_ts, 
}, {
    id: n.getFullYear() + '-' + ('0' + (n.getMonth()+1)).slice(-2) + '-' + 'b10b4c8f-559c-4e58-afb7-27753cc7835a',
    amount: 300,
    currency: 'MXN',
    destination_name: 'Here goes the destination name 3',
    destination_url: 'https://lana-dev.xyz/2092bc45-8dfd-4f3b-ad2c-32bf2494d77a',
    destination_uri: destination_account_uri,
    description: 'Here goes the description 3',
    value_ts: value_ts, 
}].map(i => {
    return {
        ...i,
        signature: buildSignature({
            id: i.id, 
            ts: i.value_ts,
            business: business_id,
            amount: i.amount,
            currency: i.currency,
            source_uri: account.gateway_uri,
            dest_uri: i.destination_uri,
        }, token)
    };
});

create_batch({batch_id: batch_data.id, description: batch_data.description}, items);`;

const NodeCreateBatch = () => <Code language="javascript" codestring={codestring} />;

export default NodeCreateBatch;
